import Result from 'folktale/result'
import { parseAxiosException } from '@/helpers/exceptionParser.js'

export default class SafeApiClient {
  constructor(apiClient) {
    this.apiClient = apiClient
  }

  async get(url) {
    try {
      const response = await this.apiClient.get(url)
      return Result.Ok(response)
    } catch (e) {
      return Result.Error(e)
    }
  }

  async post(url, payload) {
    try {
      const response = await this.apiClient.post(url, payload)
      return Result.Ok(response)
    } catch (e) {
      const parsedException = parseAxiosException(e)
      return Result.Error(parsedException)
    }
  }

  async put(url, payload) {
    try {
      const response = await this.apiClient.post(url, payload)
      return Result.Ok(response)
    } catch (e) {
      const parsedException = parseAxiosException(e)
      return Result.Error(parsedException)
    }
  }
}
